import { Component } from '@angular/core';
import { Router } from '@angular/router';


@Component({
  selector: 'app-report-tutorial',
  templateUrl: './report-tutorial.component.html',
  styleUrl: './report-tutorial.component.scss'
})
export class ReportTutorialComponent {
  constructor(private router: Router) {}

  goToNext() {
    this.router.navigate(['/home']); // Redirige a la página principal
  }
}
